import { http } from 'services/http';
import { CARGO_GET_ONE, CARGO_ITEMS_MANY } from 'api/query-keys.ts';
import type { CargoItemRes, UpdateCargoItemReq } from 'api/swagger';
import { useMutationBase } from 'shared/hooks/use-mutation-base.ts';

export const useUpdateCargoItem = (cargoId: number, cargoItemId: number) => {
  return useMutationBase<CargoItemRes, unknown, UpdateCargoItemReq>({
    mutationFn: async (variables) => {
      const res = await http.patch<CargoItemRes>(`/v1/cargo/${cargoId}/cargo-items/${cargoItemId}`, variables);

      return res.data;
    },

    invalidateCallback: () => [
      [CARGO_GET_ONE, cargoId],
      [CARGO_ITEMS_MANY, cargoId],
    ],
  });
};
